import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";

import Error from "../../components/error";
import Button from "../../components/button";
import ICTagInput from "../../components/tagInput";
import ICInput from "../../components/form/input";
import EmojiTextInput from "../../components/emojiTextInput";
import HtmlEditor from "../../components/htmlEditor";

const CreatePostForm = props => {
  const formik = useFormik({
    initialValues: {
      topic: "",
      message: "",
      tags: ""
    },
    validationSchema: Yup.object({
      topic: Yup.string()
        .min(3, "Title must be of minimum length 3")
        .max(100, "Title cannot contain more than 100 characters")
        .required("Please enter the post title"),
      message: Yup.string()
        .min(6, "Body must be of minimum length 6")
        .max(10000, "Body cannot contain more than 2000 characters")
        .required("Please enter the post body")
    }),
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });
  return (
    <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
      <EmojiTextInput
        component={ICInput}
        name="topic"
        placeholder="Topic Title*"
        value={formik.values.topic}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.topic && formik.errors.topic ? true : false}
        helperText={
          formik.touched.topic && formik.errors.topic ? formik.errors.topic : ""
        }
      />
      <br />
      <HtmlEditor
        name="message"
        value={formik.values.message}
        onChange={(newValue) => formik.setFieldValue("message", newValue)}
        onBlur={() => formik.handleBlur({ target: { name: "message" } })}
      />
      {formik.touched.message && formik.errors.message && (
          <div className="error-message" style={{ color: "red", fontSize: "0.8rem" }}>
            {formik.errors.message}
          </div>
        )}
      <br />
      <ICTagInput
        setTagsValue={val => {
          formik.setFieldValue("tags", val);
        }}
      />
      <br />
      <div>
        <Button
          className="mt-2 ic-btn-transparent-navy-blue"
          style={{ maxWidth: "141px" }}
          title="Publish Post"
          type="button"
          clickEvent={e => {
            formik.submitForm();
          }}
        />
      </div>

      <br />
      <Error>{props.serverErrorMsg}</Error>
    </form>
  );
};

export default CreatePostForm;

CreatePostForm.defaultProps = {
  serverErrorMsg: ""
};

CreatePostForm.propTypes = {
  onFormSubmit: PropTypes.func,
  serverErrorMsg: PropTypes.string
};
